import React from "react";
import classNames from "classnames/bind";
import styles from "./BrandIcon.module.scss";

const cx = classNames.bind(styles);
export const BrandIcon = () => <div className={cx("wrapper")}>브랜드</div>;
